import {
    ClientsWorkOverviewView,
    ClientsWorkOverviewViewSchema,
} from "@common/types/views/clientsWorkOverviewView";
import { ALL_WORK_VIEW } from "@components/organizationView/clients-work/views/kickWorkViews";
import {
    getWorkViewSort,
    withWorkViewSort,
} from "@components/organizationView/clients-work/workViewSort";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

interface UseClientsWorkOverviewViewStoreOptions {
    cacheKey?: ORGANIZATION_USER_CACHE_KEYS;
    /** Opens on this view instead of the cached one, e.g. a first visit's landing view. */
    initialView?: ClientsWorkOverviewView;
    /**
     * Replace the opened view's filters on mount, e.g. a client link's. The
     * view keeps its sort, which is stored with the filters (`workSort`).
     */
    initialFilters?: ClientsWorkOverviewView["filters"];
}

export function useClientsWorkOverviewViewStore({
    cacheKey,
    initialView,
    initialFilters,
}: UseClientsWorkOverviewViewStoreOptions = {}) {
    return useViewStore<ClientsWorkOverviewView>({
        defaultView: ALL_WORK_VIEW,
        initialView,
        getInitialFilters:
            initialFilters &&
            ((openedView) =>
                withWorkViewSort({
                    view: { ...openedView, filters: initialFilters },
                    sort: getWorkViewSort(openedView),
                }).filters),
        viewSchema: ClientsWorkOverviewViewSchema,
        cacheKey,
    });
}
